import React, { useState } from "react";
import Highlighter from "react-highlight-words";
import { useDispatch } from "react-redux";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import { GoEye } from "react-icons/go";
import FinalExitQueuePopup from "../FinalExitQueueTab/FinalExitQueuePopup";
import nodeinstance from "../../../../../nodeInstance";
import { setAppError } from "../../../../../store/userSlice";

export default function FinalExitQueueList({
  token,
  titles = [],
  list = [],
  loading,
  updateData,
}) {
  const [searchWords, setSearchWords] = useState([]);
  const [checkedItems, setCheckedItems] = React.useState({});
  const [checked, setChecked] = React.useState({});

  const [PopupBulk, setPopupBulk] = useState(false);
  const [propData, setPropData] = useState("");
  const onButtonClick = (data) => {
    setPopupBulk(true);
    setPropData(data);
  };

  const [listData, SetListData] = useState();

  const dispatch = useDispatch();

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination((list && list?.data) || []);

  const formatDate = (dateString) => {
    // Create a new Date object from the given dateString
    const date = new Date(dateString);

    // Check if the date object is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    // Define an array of month names
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get the individual components of the date
    const day = date.getDate();
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();

    // Construct the desired format
    const formattedDate = `${day}-${monthName.toLowerCase()}-${year}`;

    return formattedDate;
  };

  const apiCall = () => {
    updateData();
    setChecked({});
    setCheckedItems({});
  };

  function calculateDaysBetweenDates(startDate, endDate) {
    if (!startDate && !endDate) { return false };
    // Parse the dates to ensure proper format
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = start - end;

    // Convert milliseconds to days
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    console.log(".............d.d.d..d.d..d.d.", differenceInDays);

    return Math.round(differenceInDays); // Rounding to the nearest day
  }
  const onDownloadExcel = async () => {
    try {
      // Make the API call with proper headers and responseType
      const response = await nodeinstance.get("/mobilization/excelDownload", {
        responseType: "blob", // Important for binary data
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        // Create a downloadable link for the file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Exit_formalities_summary.xlsx`); // Add proper file extension
        document.body.appendChild(link);
        link.click();

        // Clean up the URL object
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);

        // Dispatch success message
        dispatch(
          setAppError({
            msg: "Excel downloaded successfully!",
            color: "success",
          })
        );
      } else {
        throw new Error("Failed to download the Excel file.");
      }
    } catch (err) {
      // Dispatch error message
      dispatch(
        setAppError({
          msg: err.message || "An error occurred while downloading the file.",
        })
      );
    }
  };
  console.log("Data log in console", currentList, list?.data?.length);
  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex space-x-2 ">
          <div className="gap-2 w-full items-center flex flex-row-reverse">
            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() => onDownloadExcel()}
            >
              <p>Download</p>
            </button>
            <Search
              searchKey={[
                "candidate_id",
                "name",
                "nationality",
                "actual_profession",
                "visa_profession",
                "iqama_number",
                "client",
              ]}
              setSearchWords={setSearchWords}
            />
          </div>
        </div>
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div
          className={`grid grid-cols-table-finalexitqueue auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {titles.map((t, index) => (
            <p key={index} className="font-semibold uppercase">
              {t}
            </p>
          ))}
          { }
          {list?.isLoading && <LoadingWithLable className="col-span-6" />}
          {Array.isArray(list?.data) && <NoDataFound />}

          {Array.isArray(list?.data)
            ? currentList?.map((list, index) => (
              <React.Fragment key={index}>
                <PaginationIndex index={index} />
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.point_of_hire || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.candidate_id || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.name || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.nationality || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.actual_profession || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.visa_profession || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.basic_salary || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={"-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.total_salary?.toString() || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.client || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={
                      list.visa_provider
                        ? list.visa_provider
                        : list.Overseas_visa_provider || "-"
                    }
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.iqama_number || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={
                      formatDate(list.iqama_expiry_date_g) || "-"
                    }
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.demobilization_type || "-"}
                  />
                </p>
                {/* <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={"-"}
                    />
                  </p> */}
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={
                      list.Final_exit_issue_date
                        ? formatDate(list.Final_exit_issue_date)
                        : "-"
                    }
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={
                      list.Final_exit_expiry_date
                        ? formatDate(list.Final_exit_expiry_date)
                        : "-"
                    }
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={calculateDaysBetweenDates(
                      list.Final_exit_expiry_date
                        ? list.Final_exit_expiry_date
                        : new Date(),
                      new Date()
                    )?.toString()}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={
                      list.demobilization_type != "NAKAL KAFALA-FINAL EXIT"
                        ? "-"
                        : list.Exit_country_or_nakal_kafala_date
                          ? formatDate(list.Exit_country_or_nakal_kafala_date)
                          : "-"
                    }
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={
                      list.demobilization_type === "NAKAL KAFALA-FINAL EXIT"
                        ? list.Exit_country_or_nakal_kafala_date
                          ? formatDate(list.Exit_country_or_nakal_kafala_date)
                          : "-"
                        : "-"
                    }
                  />
                </p>
                <p>{"-"}</p>
                {list.Final_exit_status === "UNAUTHORISE" ||
                  (list.demobilization_type === "ABSCONDING-RUN AWAY" &&
                    list.Absconding_Aging < 16) ? (
                  <GoEye fontSize={22} className="ml-2" />
                ) : (
                  <div
                    className="ml-2 cursor-pointer"
                    onClick={() => onButtonClick(list)}
                    disabled={
                      list.demobilization_type === "ABSCONDING-RUN AWAY" &&
                      list.Absconding_Aging < 16
                    }
                  >
                    <GoEye fontSize={22} className="ml-2" />
                  </div>
                )}
                <hr
                  className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                />
              </React.Fragment>
            ))
            : ""}
        </div>
        {Array.isArray(list?.data) ? <Pagination /> : ""}
      </div>

      {PopupBulk ? (
        <FinalExitQueuePopup
          PopUp={PopupBulk}
          setPopUp={setPopupBulk}
          url={"url"}
          callBack={apiCall}
          // empid={listData}
          propData={propData}
        />
      ) : (
        ""
      )}
    </>
  );
}
